module.exports = __webpack_public_path__ + "static/media/30.6c131235.svg";